/** ICD markers (`!` secondary, `*` star, `+` cross, `#`) that do not change which code is meant. */
const CODE_MARKERS = /[!#*+]/g;

/**
 * Comparison key for a code name. Stored names (e.g. in a code spectrum) can
 * carry padding, a different case or ICD markers, while the code API returns
 * the plain name — `' i12.91'`, `'I12.91!'` and `'I12.91'` are the same code.
 * Mirrors the backend's `String.toCode()` normalisation; case is folded
 * instead of per coding system, which is safe because no two codes of one
 * system differ only in case. Use it for lookups only, never as a name to
 * store or send.
 */
export function codeNameKey(name: string): string {
  return name.trim().replace(CODE_MARKERS, '').toUpperCase();
}
